import { useImportHubV2 } from '../../hooks/ff/index.js';
import { StaticContextDataV1 } from './StaticContextDataV1.jsx';
import { StaticContextDataV2 } from './StaticContextDataV2.jsx';

type StaticContextDataProps = {
  isEditable: boolean;
  switchToEditingMode: () => void;
};

export const StaticContextData = ({
  isEditable,
  switchToEditingMode,
}: StaticContextDataProps) => {
  const isImportHubV2Enabled = useImportHubV2();

  if (isImportHubV2Enabled) {
    return (
      <StaticContextDataV2
        isEditable={isEditable}
        switchToEditingMode={switchToEditingMode}
      />
    );
  }

  return (
    <StaticContextDataV1
      isEditable={isEditable}
      switchToEditingMode={switchToEditingMode}
    />
  );
};
